import React from 'react';
import 'src/style/invoice.css';

const CONFIDENCE_TIER_PILL = {
  AUTO_MATCH: 'green',
  HIGH: 'blue',
  MEDIUM: 'yellow',
  LOW: 'yellow',
  VERY_LOW: 'red',
};

export default function AISuggestionSticker({ suggestion }) {
  if (!suggestion) return null;

  const tierLabel = suggestion.confidence_tier?.replace('_', ' ') || 'N/A';
  const scoreLabel = suggestion.confidence_score
    ? ` (${Math.round(suggestion.confidence_score * 100)}%)`
    : '';
  const pillClass =
    CONFIDENCE_TIER_PILL[suggestion.confidence_tier] || 'yellow';

  return (
    <div className="div-flex-row div-align-center cg-5 ai-suggestion-sticker">
      <span className="text-xs text-semi-bold text-grey">AI Suggested</span>
      <span className={`status-pill ${pillClass} text-xs text-semi-bold`}>
        {tierLabel}
        {scoreLabel}
      </span>
    </div>
  );
}
